import { WindowLocationServiceInterface } from 'pf-frontend-common/src/service/window-location/service.interface';

import { ContentGroupStrategyOptionsInterface } from 'common/module/content-group/strategy-options.interface';
import { ContentGroupView } from 'common/module/content-group/view';
import { ContentGroupViewCssClassInterface } from 'common/module/content-group/view/css-class.interface';
import { ContentGroupViewCssSelectorInterface } from 'common/module/content-group/view/css-selector.interface';
import { ContentGroupViewDataAttrInterface } from 'common/module/content-group/view/data-attr.interface';

import { ContentGroupStrategyInterface } from '../strategy.interface';

/**
 * Expand and collapse content group sections in a 'tab' style
 */
export class ContentGroupStrategyTab implements ContentGroupStrategyInterface {
  /**
   * @inheritDoc
   */
  public dataAttr: ContentGroupViewDataAttrInterface = {
    buttonTargetAccessor: 'qsTab',
  };

  /**
   * @inheritDoc
   */
  public cssSelector: ContentGroupViewCssSelectorInterface = {
    buttons: '[data-qs-tab]',
    button: '[data-qs-tab="{name}"]',
    content: '[data-qs-content="{name}"]',
  };

  /**
   * @inheritDoc
   */
  public cssClass: ContentGroupViewCssClassInterface = {
    buttonActive: 'tab__button--active',
    contentActive: 'tab__content--active',
  };

  /**
   * Serialize to URL
   */
  private serializeToUrl: boolean = false;

  /**
   * Constructor
   */
  constructor(private windowLocationService: WindowLocationServiceInterface) {}

  /**
   * @inheritdoc
   */
  public initialize(options: ContentGroupStrategyOptionsInterface): void {
    this.serializeToUrl = options.serializeToUrl;
  }

  /**
   * @inheritDoc
   */
  public activate(view: ContentGroupView, name: string): void {
    if (this.serializeToUrl) {
      this.windowLocationService.replace(this.windowLocationService.getPathname(), {
        hash: this.windowLocationService.getHash(),
        queryData: {
          ...this.windowLocationService.getQueryData(),
          tab: name,
        },
      });
    }
    return;
  }

  /**
   * @inheritDoc
   */
  public deactivate(): void {
    return;
  }

  /**
   * @inheritDoc
   */
  public change(view: ContentGroupView, name: string): void {
    const activeSections = view.getActiveSections();

    if (name && activeSections[name]) {
      return;
    }

    // Deactivate all active tabs
    Object.keys(activeSections).forEach((section) => view.deactivate(section));

    // Activate tab
    view.activate(name);
  }
}
